// Simple sorting logic for texts and numbers
// If a value is to be compared parse it and then pass
export const basicSorter = (a, b) => {
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
};

// Pass only parsed moment objects
export const dateSorter = (a, b) => {
  if (a.isAfter(b)) {
    return -1;
  }
  if (a.isBefore(b)) {
    return 1;
  }
  return 0;
};

//  As for Bug Id 6215, we need to sort parenthesis as a negative number so in this function we are making that negative first then we are applying  sorting on it
//  a => first amount as number, b => second amount as number
//  isANegative => is firstAmount negative (true/false), isBNegative => is secondAmount negative (true/false)
export const sortAsNegativeSymbol = (a, b, isANegative, isBNegative) => {
  const aNum = isANegative ? Number(-a) : Number(a);
  const bNum = isBNegative ? Number(-b) : Number(b);
  return aNum - bNum;
};
